/** @format */
import { ChangeDetectionStrategy, Component, computed, Input, Signal, signal, ViewEncapsulation, WritableSignal } from '@angular/core';
import { CreditsRuleValidationResult } from 'common-typescript';
import { CreditRange, CreditsRule, EntityWithRule, PlanValidationState, RangeValidationResultState } from 'common-typescript/types';
import * as _ from 'lodash-es';

@Component({
    selector: 'sis-plan-structure-credit-rule-header',
    templateUrl: './plan-structure-credit-rule-header.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class PlanStructureCreditRuleHeaderComponent {
    _rule: WritableSignal<CreditsRule> = signal(undefined);
    @Input({ required: true }) set rule(rule: CreditsRule) {
        this._rule.set(rule);
    }

    _ruleValidationResults: WritableSignal<CreditsRuleValidationResult> = signal(undefined);
    @Input({ required: true }) set ruleValidationResults(ruleValidationResults: CreditsRuleValidationResult) {
        this._ruleValidationResults.set(ruleValidationResults);
    }

    _parentModule: WritableSignal<EntityWithRule> = signal(undefined);
    @Input({ required: true }) set parentModule(parentModule: EntityWithRule) {
        this._parentModule.set(parentModule);
    }

    @Input() ruleLegendId: string;
    @Input({ required: true }) ruleDepthLevel: number;
    @Input() onlyShowRule: boolean;

    targetCredits: Signal<CreditRange> = computed(this.targetCreditsComputation());
    plannedCredits: Signal<CreditRange> = computed(this.plannedCreditsComputation());
    rangeValidationResultState: Signal<RangeValidationResultState> = computed(this.rangeValidationResultStateComputation());
    planValidationState: Signal<PlanValidationState> = computed(this.planValidationStateComputation());

    targetCreditsComputation(): () => CreditRange {
        return () => {
            if (this.ruleDepthLevel === 1 && _.get(this._parentModule(), 'targetCredits')) {
                return {
                    min: _.get(this._parentModule(), 'targetCredits.min', null),
                    max: _.get(this._parentModule(), 'targetCredits.max', null),
                };
            }
            return {
                min: this._rule()?.credits?.min,
                max: this._rule()?.credits?.max || null,
            };
        };
    }

    plannedCreditsComputation(): () => CreditRange {
        return () => this._ruleValidationResults()?.plannedCredits;
    }

    rangeValidationResultStateComputation(): () => RangeValidationResultState {
        return () => this._ruleValidationResults()?.result;
    }
    planValidationStateComputation(): () => PlanValidationState {
        return () => this._ruleValidationResults()?.contextualState;
    }
}
